import { handleActions } from "redux-actions";
import { SCOPE_BRAND_SET, PROMOTIONS } from "constants/action-types";
import { PriceEntity } from "containers/admin/promotions/entity/price-entity/promotions.types";

export interface INamespace {
    error?: Error;
    isLoading: boolean;
    entity: PriceEntity;
}

export interface IState {
    isLoading: boolean;
    entity: PriceEntity;
}

export const initialState: IState = {
    isLoading: true,
    entity: null,
};

export const promotionReducer = handleActions<IState, null | PriceEntity>(
    {
        [SCOPE_BRAND_SET]: () => {
            return initialState;
        },
        [PROMOTIONS.CURRENT.CLEAR]: () => {
            return initialState;
        },
        [PROMOTIONS.CURRENT.FETCH.START]: (state: IState) => {
            return { ...state, isLoading: true };
        },
        [PROMOTIONS.CURRENT.FETCH.SUCCESS]: (state: IState, { data }: any) => {
            return { ...state, isLoading: false, entity: data };
        },
        [PROMOTIONS.CURRENT.FETCH.ERROR]: (state: IState) => {
            return { ...state, isLoading: false };
        },
    },
    initialState,
);
